module.exports = __webpack_public_path__ + "static/media/boss-double-attack.97595a52.png";